<template>
  <div class="libox" @click="goDetail(list)">
    <div v-if="list.CLASS_NAME" class="topColumnname" @click="gocolumn(list.COLUMN_ID)">
      {{ list.CLASS_NAME }}
    </div>
    <div v-if="list.COLUMN_NAME" class="topColumnname" @click="gocolumn(list.COLUMN_ID,list.COLUMN_NAME)">
      {{ list.COLUMN_NAME }}
    </div>
    <div class="imgbox">
      <img v-if="list.CONTENT_PHOTO_SMALL" :src="list.CONTENT_PHOTO_SMALL" alt="">
      <img v-if="list.CONTENT_PHOTO&&!list.CONTENT_PHOTO_NAME" :src="list.CONTENT_PHOTO" alt="" :class="list.SHOW_TYPE=='谱书'?'ispushu':'nopushu'">
      <img v-if="!list.CONTENT_PHOTO" :src="noIMG" alt="">
      <p v-if="reversedMessage.CONTENT_PHOTO_NAME">
        {{ reversedMessage.CONTENT_PHOTO_NAME }}
      </p>
    </div>
    <p class="mgslist_p">
      <span class="titlename">{{ list.CONTENT_TITLE }}</span>
      <span v-if="list.CREATE_DATE" class="hot_time">{{ list.CREATE_DATE|changeTime }}</span>
      <span v-if="list.CONTENT_ISSUE_DATE" class="hot_time">{{ list.CONTENT_ISSUE_DATE|changeTime }}</span>
      <span class="el-icon-view viewNumber">   {{ list.CONTENT_READING_SIZE|changenum }}</span>
      <span class="viewNumber viewStar"><svg-icon icon-class="pinlun" />   {{ list.CONTENT_SPEAK_SIZE|changenum }}</span>
    </p>
    <div v-if="list.TEMPLATE_ID==='VIDEO'" class="vdoIMG" />
    <div v-if="list.TEMPLATE_ID==='PHOTO'" class="tuji">
      {{ list.CONTENT_PHOTO_SIZE }}图
    </div>
  </div>
</template>
<script>
// ///首页列表模板上中下形式
export default {
  name: 'ListTemolate1',
  props: ['list'],
  data() {
    return {
      noIMG: require('@/static/home_noimg.png')
    }
  },
  computed: {
    reversedMessage: function() {
      var newlist = this.list
      if (this.list.CONTENT_PHOTO) {
        var str = /^http/
        if (!str.test(this.list.CONTENT_PHOTO)) {
          newlist.CONTENT_PHOTO_NAME = this.list.CONTENT_PHOTO
        }
      }
      return newlist
    }
  },
  methods: {
    gocolumn: function(contentId, name) {
      if (!this.list.SHOW_RES_TYPE) {
        window.location.href = '/column/?columnId=' + contentId
      }
    },
    goDetail: function(list) {
      if (list.SHOW_RES_TYPE <= 6) {
        const { href } = this.$router.resolve({
          path: '/sourceView',
          name: 'sourceView',
          query: {
            'sourceId': list.CONTENT_ID,
            'type': list.SHOW_RES_TYPE
          }
        })
        window.open(href, '_blank')
      } else {
        const { href } = this.$router.resolve({
          path: '/Detail',
          name: 'dt',
          query: {
            'contentId': list.CONTENT_ID
          }
        })
        window.open(href, '_blank')
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .libox{
        display: inline-block;
        width: 100%;
        font-size: 0;
        cursor: pointer;
        position: relative;
        .topColumnname{
            text-align: center;
            position: absolute;
            top:10px;
            left: 10px;
          padding: 0 5px;
            background-color:rgba(51,51,51,.5);
            font-size: 12px;
            color: #ffffff;
            height: 18px;
            line-height: 18px;
            border-radius: 3px;
            cursor: pointer;
            &:hover{
                background-color: rgba(237,64,64,.5);
            }
        }
        .imgbox{
            display: inline-block;
            width: 268px;
            height: 183px;
            font-size: 0;
           text-align: center;
           overflow: hidden;
            img{
                width: 100%;
                height: 100%;
            }
          p{
            width: 268px;
            height: 183px;
            line-height: 183px;
            text-align: center;
            font-size: 25px;
            font-weight: 600;
            background-color: #F5F5F5;
            color: #505050;
            padding: 0 0;
          }
          .ispushu{
            height: 100%;
            width: 150px;
          }
        }
        .mgslist_p{
            width: 256px;
            height: 93px;
            border-left: 1px solid #f0f0f0;
            border-right: 1px solid #f0f0f0;
            border-bottom: 1px solid #f0f0f0;
            -moz-box-shadow:1px 1px 3px #f3f3f3;
            -webkit-box-shadow:1px 1px 3px #f3f3f3;
            box-shadow:1px 1px 3px #f3f3f3;
            text-align: left;
            padding-left: 10px;
            .titlename{
                color: #333333;
                font-size: 14px;
                font-weight:500;
                display: inline-block;
                padding-top: 8px;
                height:55px;
                line-height: 25px;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            .hot_time{
                display: inline-block;
                width: 147px;
                height: 20px;
                font-size: 12px;
                color: #b2b2b2;
            }
            .viewNumber{
                display: inline-block;
                height: 20px;
                width: 50px;
                font-size: 12px;
                color: #b2b2b2;
                text-align: right;
                svg{
                    vertical-align:middle;
                }
            }
            .viewStar{
                width: 50px;
            }
        }
    }
    .vdoIMG{
        width: 50px;
        height: 50px;
        border-radius: 50%;
        border: 3px solid rgba(249,245,246,.5);
        position: absolute;
        top: 66.5px;
        left: 112.5px;
        cursor: pointer;
    }
    .vdoIMG::after{
        content: '';
        display: block;
        position: absolute;
        top: 13px;
        left: 15px;
        width: 0;
        height: 0;
        border-top: 12px solid transparent;
        border-bottom:  12px solid transparent;
        border-left:20px solid rgba(247,247,247,.5);
    }
    .tuji{
        position: absolute;
        width: 36px;
        height: 18px;
        line-height: 18px;
        font-size: 12px;
        text-align: center;
        color: #ffffff;
        top: 150px;
        background-color:rgba(51,51,51,.5);
        border-radius: 5px;
        right: 10px;
        &:hover{
            background-color: rgba(237,64,64,.5);
        }
    }

</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px){
    .libox{
      .topColumnname{
        display: none;
      }
      .imgbox{
        width: 30%;
        height: 80px;
        .ispushu{
          width: 100%;
          height: auto;
        }
        p{
          width: 100%;
          height: 100%;
          line-height: 80px;
        }
      }
      .mgslist_p{
        height: auto;
        width: 70%;
        display: inline-block;
        vertical-align: top;
        box-shadow:none;
        border: none;
        padding-left: 0;
        .titlename{
          padding-top: 0;
          padding-left: 5px;
        }
        .hot_time{
          width: 110px;
          text-align: center;
        }
        .viewNumber{
          width: 60px;
        }
        .viewStar{
          width: 60px;
        }
      }
    }
  }
</style>
